var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88,
    filter: "url(#filter0_d_168_798)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "verified-background",
    x: 6,
    y: 6,
    width: 88,
    height: 88,
    rx: 44,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 82,
    height: 82,
    rx: 41,
    stroke: "#038501",
    strokeWidth: 6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5041 74C46.0064 74 45.5282 73.7983 45.1585 73.4328L26.6113 55.0236C25.8235 54.228 25.7934 52.956 26.5427 52.124L30.8406 47.4337C31.2256     47.0129 31.7724 46.7723 32.3408 46.7723C32.8722 46.7723 33.375 46.977 33.758 47.3466L44.8062 58.0635L64.6037 26.9481C64.9826 26.3543 65.6277 26     66.3312 26C66.7306 26 67.1197 26.1157 67.4546 26.3358L73.0693 30.0259C74.0109 30.6508 74.2818 31.9129 73.6796 32.8691L48.0974 73.1031C47.7411 73.6642     47.1451 74 46.5051 74H46.5041Z",
    fill: "#038501"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_168_798",
    x: 4,
    y: 6,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.4 0 0 0 0 1 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_168_798"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_168_798",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.57380712c36eea3deb13f539286de32f.svg";
export { ForwardRef as ReactComponent };